import 'antd/dist/antd.css'
import 'react-image-gallery/styles/css/image-gallery.css'
import './App.css'
import './header.css'
import './history.css'
import { Input, message, Button, Result, Drawer, List, Divider } from 'antd'
import ImageGallery from 'react-image-gallery'
import { TranslationOutlined, UserOutlined, ArrowRightOutlined, CheckCircleOutlined, StopOutlined, LoadingOutlined, SisternodeOutlined, PictureOutlined, WarningOutlined } from '@ant-design/icons'
import { Component } from 'react'
import _ from 'lodash'
import axios from 'axios'
import DefaultItems from './default-items'
import franc from 'franc-min'
import texts from './texts'
import dateformat from 'dateformat'

// const API_HREF = (process.env.NODE_ENV === 'production') ? (process.env.PUBLIC_URL +'/api') : 'https://lab.aminer.cn/cogview/api'// 'http://localhost:19385'
const API_HREF = 'https://wudao.aminer.cn/api/cogview/'

const USERNAME_CACHE_KEY = 'cogview.v1.username'

export default class App extends Component {
    constructor(props) {
      super(props)
      this.state = {
        model: 'login',
        username: localStorage.getItem(USERNAME_CACHE_KEY) || '',
        query: '一只戴墨镜的猫趴在桌子上。',
        loading: false,
        task: undefined,
        displayHistory: false,
        historyTasks: [],
        waitingTasks: [],
        waitingTime: 0,
        enableTrans: false,
        lang: (navigator.language || navigator.userLanguage) === 'en' ? 'en' : 'zh'
      }
      this.poll_process = undefined
      this.poll_interval = 5
      this.last_submit_time = 0
      this.refreshWaitingTasks()
      this.refresh_process = setInterval(() => {
        this.refreshWaitingTasks()
        this.refreshHistoryTasks()
      }, 5000)
    }

    refreshWaitingTasks() {
      axios.get(`${API_HREF}/waiting`).then(resp => {
        this.setState({waitingTasks: resp.data.tasks, waitingTime: Math.ceil(resp.data.estimate_time / 60)})
      }).catch(err => {
        console.log(this.t("service_err", {err}))
      })
    }

    refreshHistoryTasks() {
      axios.get(`${API_HREF}/history`).then(resp => {
        this.setState({historyTasks: resp.data.tasks})
      }).catch(err => {
        console.log(this.t("service_err", {err}))
      })
    }

    t(code, dict) {
      let text = texts[code][this.state.lang]
      if (dict) {
        Object.keys(dict).forEach(key => {
          text = text.replace('%' + key, dict[key])
        })
      }
      return text
    }

    datestr(t) {
      return dateformat(new Date(t), "yyyy/mm/dd h:MM:ss")
    }

    detectTrans = _.debounce(() => {
      console.log('length', this.state.query.trim().length)
        if (this.state.query.trim().length < 5) this.setState({enableTrans: false})
        const lang = franc(this.state.query + ' ')
        this.setState({enableTrans: lang !== 'cmn' && lang !== 'und'})
    }, 500)

    translate() {
      this.setState({loading: true})
      axios.post(`${API_HREF}/translate`, {query: this.state.query}).then(resp => {
        const data = resp.data
        if (data.status) {
          this.setState({loading: false, enableTrans: false, query: data.text})
          message.success(this.t("translation_succeed"))
        } else {
          this.setState({loading: false, enableTrans: false})
          message.warning(this.t("translation_failed") + data.message)
        }
      }).catch(err => {
        this.setState({loading: false, enableTrans: false})
        message.error(this.t("service_err", {err}))
      })
    }

    renderLogin() {
      const disabled = this.state.query.trim().length < 2 || this.state.username.trim().length === 0 || this.state.query.trim().length > 30
      return (
        <div className="login">
          <div className="logo" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/logo.png'})`}}/>
          <div id="logo-description">{this.t("title")}</div>
          <Input.Group className="login-input">
            <Input
              size="large"
              placeholder={this.t("name_placeholder")}
              prefix={<div><UserOutlined className="site-form-item-icon" /><span className="input-inner-header">{this.t("name_prompt")}</span></div>}
              suffix={
                <ArrowRightOutlined className="btn" style={{color: 'white'}}/>
              }
              value={this.state.username}
              onChange={e => this.setState({username: e.target.value})}
            />
          </Input.Group>
          <Input.Group className="login-input">
            <Input
              size="large"
              placeholder={this.t("input_placeholder")}
              prefix={<div><PictureOutlined className="site-form-item-icon" /><span className="input-inner-header">{this.t("input_prompt")}</span></div>}
              suffix={
                <div>
                  {this.state.enableTrans && <TranslationOutlined className="enter-btn" style={{color: this.state.loading ? 'lightgray' : 'black'}} onClick={() => this.translate()}/>}
                  <ArrowRightOutlined className="enter-btn" style={{color: disabled ? 'lightgray' : 'black'}} onClick={() => this.generate()}/>
                </div>
              }
              value={this.state.query}
              onChange={e => {
                this.detectTrans()
                this.setState({query: e.target.value})
              }}
              onPressEnter={() => this.generate()}
            />
          </Input.Group>
          <div className="login-btns">
            <div className="prompt">
              <p>{this.t("warning_text")}</p>
            </div>
            {(this.state.task !== undefined && this.state.task.status === 'Succeed' && this.state.task.query === this.state.query.trim()) ?
              <Button className="wbtn login-btn" onClick={() => this.generate(true)} disabled={disabled}>{this.t("regenerate")}</Button> :
              <Button className="wbtn login-btn" onClick={() => this.generate()} disabled={disabled}>{this.t("generate")}</Button>
            }
            <Button className="wbtn history-display-btn" onClick={() => this.showHistory()}>{this.t("show_history")}</Button>
            <Button className="wbtn lang-btn" onClick={() => this.setState({lang: this.state.lang === 'zh' ? 'en' : 'zh'})}>{this.t("switch_lang")}</Button>
            <Button className="wbtn github-btn" onClick={() => window.location.href = 'https://github.com/THUDM/CogView'}>{this.t("github")}</Button>
          </div>
        </div>
      )
    }

    updateHistory(displayHistory) {
      this.setState({loading: true})
      axios.get(`${API_HREF}/history`).then(resp => {
        this.setState({loading: false, historyTasks: resp.data.tasks, displayHistory})
        message.info(this.t("load_history_records", {size: resp.data.tasks.length}))
      }).catch(err => {
        message.error(this.t("service_err", {err}))
        this.setState({loading: false})
      })
    }

    showHistory() {
      if (this.state.historyTasks.length === 0) {
        this.updateHistory(true)
      } else {
        this.setState({displayHistory: true})
      }
    }

    poll(task) {
      if (task === undefined) task = this.state.task
      if (task === undefined || task.status === 'Succeed' || task.status === 'Fail') return
      if (this.poll_process) clearInterval(this.poll_process)
      this.poll_process = setInterval(() => {
        axios.get(`${API_HREF}/get/${task._id}`).then(resp => {
          const task = resp.data.task
          if (task.status === 'Succeed' || task.status === 'Fail') {
            clearInterval(this.poll_process)
            if (task.status === 'Succeed') message.success(this.t("generation_succeed_all_img", {size: task.num_images}))
          }
          if (task._id !== this.state.task._id || task.status !== this.state.task.status) this.setState({task})
        }).catch(err => {
          message.error(this.t("service_err", {err}))
          clearInterval(this.poll_process)
        })
      }, this.poll_interval * 1000)
    }

    generate(force_refresh) {
      if (force_refresh === undefined) force_refresh = false
      if (this.poll_process) clearInterval(this.poll_process)
      if (this.state.username.trim().length === 0) {
        message.warning(this.t("input_name_not_empty"))
        this.setState({task: undefined})
      }
      else if (this.state.query.trim().length < 2 || this.state.query.trim().length > 30) {
        message.warning(this.t("input_length_not_valid", {size: this.state.query.trim().length}))
        this.setState({task: undefined})
      }
      else if (Date.now() - this.last_submit_time < 5000) {
        message.warning(this.t("submit_too_fast"))
        this.setState({task: undefined})
      }
      else {
        this.last_submit_time = Date.now()
        localStorage.setItem(USERNAME_CACHE_KEY, this.state.username)
        this.setState({loading: true, task: undefined})
        axios.post(`${API_HREF}/generate`, {username: this.state.username, query: this.state.query, force_refresh, lang: this.state.lang}).then(resp => {
          const status = resp.data.status
          if (!status) {
            message.info(`${this.t("request_failed")}${resp.data.message}`)
            this.setState({loading: false})
            return
          }
          const task_id = resp.data._id
          axios.get(`${API_HREF}/get/${task_id}`).then(resp => {
            const task = resp.data.task
            if (task.status === 'Succeed') message.success(this.t("generation_succeed_all_img", {size: task.num_images}))
            this.setState({loading: false, task})
            this.poll(task)
          }).catch(err => {
            message.error(this.t("service_err", {err}))
            this.setState({loading: false})
          })
        }).catch(err => {
          message.error(this.t("service_err", {err}))
          this.setState({loading: false})
        })
      }
    }

    renderTask() {
      const task = this.state.task
      const status = task ? task.status : 'Not Found'
      return <div className="task-display">
        {status === 'Not Found' && <Result
          status="warning"
          title={this.t("task_not_found")}
          subTitle={this.t("plz_regenerate")}
        />}
        {status === 'Fail' && <Result
          status="error"
          title={this.t("generate_fail")}
          subTitle={this.t("plz_regenerate_or_other")}
        />}
        {status === 'Created' && <Result
          icon={<SisternodeOutlined/>}
          title={this.t("submitted_and_queue")}
          subTitle=""
        />}
        {status === 'Running' && <Result
          icon={<LoadingOutlined/>}
          title={this.t("generating")}
          subTitle={this.t("generate_and_wait")}
        />}
        {status === 'Succeed' && <ImageGallery
          showIndex={true}
          showFullscreenButton={false}
          showPlayButton={false}
          items={_.range(task.num_images).map(key => {
            const url = `${API_HREF}/get-image/${task.qid}/${task.created_time}/${key}.jpg`
            return { original: url, thumbnail: url, height: 96, width: 96 }
          })}
        />}
      </div>
    }

    renderDefaultPlay() {
      return <div className="task-display">
        <ImageGallery
          className="task-image-gallery"
          showIndex={true}
          showFullscreenButton={false}
          showPlayButton={false}
          items={DefaultItems.map(item => {
            const url = `${API_HREF}${item.original}`
            return { ...item, original: url, thumbnail: url }
          })}
        />
      </div>
    }

    renderIcon(status) {
      if (status === 'Succeed') return <CheckCircleOutlined style={{color: '#73d13d'}}/>
      if (status === 'Fail') return <StopOutlined style={{color: '#ff7a45'}}/>
      if (status === 'Created') return <SisternodeOutlined style={{color: '#40a9ff'}}/>
      if (status === 'Running') return <LoadingOutlined style={{color: '#36cfc9'}}/>
      return <WarningOutlined style={{color: '#ffec3d'}}/>
    }

    renderHistory() {
      return <Drawer
        title={
          <div className="history-title">
            <span>{this.t("history_records")}</span>
          </div>
        }
        placement="right"
        closable={true}
        onClose={() => this.setState({displayHistory: false})}
        visible={this.state.displayHistory}
        width={'300px'}
      >
        <List
          itemLayout="horizontal"
          dataSource={this.state.historyTasks}
          renderItem={historyTask => {
            return <List.Item actions={[]}>
              <List.Item.Meta
                className="history-item"
                avatar={this.renderIcon(historyTask.status)}
                title={historyTask.query}
                description={<div className="history-description">
                  <p>{`${this.t("author_prompt")}${historyTask.username}`}</p>
                  <p>{`${this.t("create_time_prompt")}${this.datestr(historyTask.created_time)}`}</p>
                  <p>{`${this.t("generate_time_prompt")}${this.datestr(parseInt(historyTask.updated_time))}`}</p>
                </div>}
                onClick={() => {
                  if (this.poll_process) clearInterval(this.poll_process)
                  this.setState({query: historyTask.query, task: historyTask, displayHistory: false})
                }}
              />
            </List.Item>
          }}
        />
      </Drawer>
    }

    componentWillUnmount() {
      if (this.poll_process) clearInterval(this.poll_process)
    }

    renderWaitingList() {
      return <div className="waiting-list">
        <Divider>
          {this.t("queue_list", {size: (this.state.waitingTasks.length >= 20) ? '≥20' : this.state.waitingTasks.length})}
          {this.state.waitingTasks.length > 0 && (this.t("queue_time", {size: (this.state.waitingTime >= 15) ? '≥15' : this.state.waitingTime}))}
        </Divider>
        <div className="items">
          {this.state.waitingTasks.map((waitingTask, idx) => {
            return <div className="item" key={idx}>
              {this.renderIcon(waitingTask.status)}
              <div className="content">
                <span className="title">{waitingTask.query}</span>
                <br/>
                <span className="time">[{this.datestr(waitingTask.created_time)}]</span>
                <span className="author">（{waitingTask.username}）</span>
              </div>
            </div>
          })}
        </div>
      </div>
    }

    render() {
      return (
        <div className="App" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/background.jpg)`, backgroundSize: 'cover'}}>
          <div className="App-background"/>
          <div className="App-inner">
            {this.state.model === 'login' && this.renderLogin()}
            {this.state.task && this.renderTask()}
            {!this.state.task && this.renderDefaultPlay()}
            {this.renderWaitingList()}
          </div>
          {this.renderHistory()}
          {this.state.loading && <div className="loading-mask">
            <div className="mask-inner"><LoadingOutlined /></div>
          </div>}
        </div>
      )
    }
}